const data = {
    mainHeadding: "Look up Not-for-Profit Organisations and access the information and insights you need to give with confidence!",
    subHeadding: "Access our vast collection of verified NPO profiles, make choices backed by facts, engage with NPOs you can trust and support causes that resonate with your values!",
    MainSideImg: "../../../../public/Images/Frame 16.png",
    inputPlaceHolder: "Enter organisation name or keyword or GSN/PAN/Darpan ID/FCRA Number"
}
export { data }